var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoInBee(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 209.337,
    height: 52.556,
    viewBox: "0 0 209.337 52.556",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_21473",
    "data-name": "Raggruppa 21473",
    transform: "translate(16424.525 -12636.22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_33106",
    "data-name": "Tracciato 33106",
    d: "M177.3,1793.71a12.772,12.772,0,1,0,12.539-19.2l-11.166-.07V1773.3l11.238.071a13.919,13.919,0,1,1-13.219,21.535q.329-.581.608-1.193",
    transform: "translate(-16573.332 10886.916)",
    fill: "#191a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_33107",
    "data-name": "Tracciato 33107",
    d: "M159.624,1756.324h-1.145v-6.062l-.068.059.06-2.583,0-.126c0-.055,0-.109,0-.164a12.775,12.775,0,1,0-19.923,10.584q-.557.289-1.088.621a13.915,13.915,0,1,1,22.156-11.206c0,.105-.005.211-.008.316l.008-.007Z",
    transform: "translate(-16555.52 10902.691)",
    fill: "#191a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_33108",
    "data-name": "Tracciato 33108",
    d: "M145.387,1772.231h-.215c-.132,0-.266,0-.4,0l-.649.03-.265.017a14.627,14.627,0,0,0-13.338,13.361l-.012.666-.036,15.13h14.6l.3,0,.045,0,.869-.05A14.627,14.627,0,0,0,159.634,1788l.014-1.167.032-14.6Zm-.311,27.922c-.057,0-.115,0-.172,0l-1.676-.027L131.8,1788.7l-.041-1.682c0-.06,0-.12,0-.18a13.231,13.231,0,0,1,1.876-6.806l18.249,18.248a13.233,13.233,0,0,1-6.806,1.876m13.315-13.5c0,.061,0,.122,0,.183a13.232,13.232,0,0,1-1.441,6.015l-17.892-17.892a13.235,13.235,0,0,1,6.015-1.441c.062,0,.124,0,.186,0l1.167,0h1.69l10.276,10.276v1.492Z",
    transform: "translate(-16555 10887.338)",
    fill: "#f6aa4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_33109",
    "data-name": "Tracciato 33109",
    d: "M193.568,1758.5a7.966,7.966,0,1,0-11.277-.012,7.974,7.974,0,0,0,11.277.012",
    transform: "translate(-16574.635 10898.188)",
    fill: "#f6aa4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_33110",
    "data-name": "Tracciato 33110",
    d: "M359.338,1772.208a8.7,8.7,0,0,1,3.479.7,8.874,8.874,0,0,1,2.837,1.905,8.916,8.916,0,0,1,1.926,9.8,2.381,2.381,0,0,0,0,4.183,8.886,8.886,0,0,1-1.926,9.8,8.891,8.891,0,0,1-2.837,1.906,8.713,8.713,0,0,1-3.479.7h-12.9v-28.994Zm-6.172,11.121h6.172a2.227,2.227,0,0,0,2.216-2.2,2.214,2.214,0,0,0-.662-1.553,2.16,2.16,0,0,0-1.553-.643h-6.172Zm0,11.143h6.172a2.162,2.162,0,0,0,1.553-.642,2.218,2.218,0,0,0,.662-1.553,2.264,2.264,0,0,0-2.216-2.216h-6.172Z",
    transform: "translate(-16640.672 10887.346)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_33111",
    "data-name": "Tracciato 33111",
    d: "M359.338,1772.208a8.7,8.7,0,0,1,3.479.7,8.874,8.874,0,0,1,2.837,1.905,8.916,8.916,0,0,1,1.926,9.8,2.381,2.381,0,0,0,0,4.183,8.886,8.886,0,0,1-1.926,9.8,8.891,8.891,0,0,1-2.837,1.906,8.713,8.713,0,0,1-3.479.7h-12.9v-28.994Zm-6.172,11.121h6.172a2.227,2.227,0,0,0,2.216-2.2,2.214,2.214,0,0,0-.662-1.553,2.16,2.16,0,0,0-1.553-.643h-6.172Zm0,11.143h6.172a2.162,2.162,0,0,0,1.553-.642,2.218,2.218,0,0,0,.662-1.553,2.264,2.264,0,0,0-2.216-2.216h-6.172Z",
    transform: "translate(-16640.672 10887.346)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.42
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_33112",
    "data-name": "Tracciato 33112",
    d: "M401.051,1778.938v4.391h11.142v6.73H401.051v4.412h14.311v6.73H394.32v-28.994h21.042v6.731Z",
    transform: "translate(-16659.668 10887.348)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_33113",
    "data-name": "Tracciato 33113",
    d: "M401.051,1778.938v4.391h11.142v6.73H401.051v4.412h14.311v6.73H394.32v-28.994h21.042v6.731Z",
    transform: "translate(-16659.668 10887.348)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.42
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_33114",
    "data-name": "Tracciato 33114",
    d: "M448.97,1778.938v4.391h11.142v6.73H448.97v4.412h14.311v6.73H442.239v-28.994h21.042v6.731Z",
    transform: "translate(-16678.68 10887.348)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_33115",
    "data-name": "Tracciato 33115",
    d: "M448.97,1778.938v4.391h11.142v6.73H448.97v4.412h14.311v6.73H442.239v-28.994h21.042v6.731Z",
    transform: "translate(-16678.68 10887.348)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.42
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_33116",
    "data-name": "Tracciato 33116",
    d: "M263.932,1778.938v15.533H269.5v6.73H251.63v-6.73H257.2v-15.533H251.63v-6.731H269.5v6.731Z",
    transform: "translate(-16603.064 10887.348)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_33117",
    "data-name": "Tracciato 33117",
    d: "M263.932,1778.938v15.533H269.5v6.73H251.63v-6.73H257.2v-15.533H251.63v-6.731H269.5v6.731Z",
    transform: "translate(-16603.064 10887.348)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.42
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_33118",
    "data-name": "Tracciato 33118",
    d: "M309.028,1801.2l-10.749-15.844V1801.2h-6.731v-28.994h5.944l10.748,15.843v-15.843h6.731V1801.2Z",
    transform: "translate(-16618.9 10887.346)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_33119",
    "data-name": "Tracciato 33119",
    d: "M309.028,1801.2l-10.749-15.844V1801.2h-6.731v-28.994h5.944l10.748,15.843v-15.843h6.731V1801.2Z",
    transform: "translate(-16618.9 10887.346)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.42
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoInBee);
export default __webpack_public_path__ + "static/media/logoInBee.bd4124db010656a87379d90738c14045.svg";
export { ForwardRef as ReactComponent };